// extracted by mini-css-extract-plugin
module.exports = {"message":"message__8BfUq","messageIcon":"messageIcon__1Isnd"};